<template>
  <div>
    <b-row>
      <b-col>
        <md-field>
          <label>{{$t('Type to Search')}}</label>
          <md-input v-model="filter" @update="filterChanged" @keypress="currentPage = 1"></md-input>
        </md-field>
      </b-col>
    </b-row>

    <basic-table
      v-if="house"
      :items="house"
      :fields="houseFields"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      @Filtred="Filtred"
      @RowSelected="rowHouseClickHandler"
      @onRowDoubleClick="onRowDoubleClick"
      isEdit="false"
      isDelete="false"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>

    <modal-ok-cancel @save="selectHouse" @cancel="hideFormHouse" buttonSaveLabel="Ok" size="lg"/>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: null
  },
  data () {
    return {
      selectedHouse: null,
      houseFields: [
        {key: 'house_id', label: 'ID', sortable: true},
        {key: 'zonesIdString', label: this.$i18n.t('IP zone ID'), sortable: true},
        {key: 'connect_date', label: this.$i18n.t('Connected on'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'post_code', label: this.$i18n.t('Zip code'), sortable: true},
        {key: 'country', label: this.$i18n.t('Country'), sortable: true},
        {key: 'region', label: this.$i18n.t('Province/State'), sortable: true},
        {key: 'city', label: this.$i18n.t('City'), sortable: true},
        {key: 'street', label: this.$i18n.t('Street'), sortable: true},
        {key: 'number', label: this.$i18n.t('Building#'), sortable: true},
        {key: 'building', label: this.$i18n.t('Constr.#'), sortable: true}
      ],
      options: {
        isShowAddButton: false
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    onRowDoubleClick (item, index, event) {
      if (this.selectedHouse) {
        this.selectedHouse._rowVariant = ''
      }
      this.selectedHouse = item
      this.$set(this.selectedHouse, '_rowVariant', 'info')
      this.selectHouse()
    },
    selectHouse () {
      if (!this.selectedHouse) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select house'), 'Error')
        return
      }
      this.$emit('input', this.selectedHouse.house_id)
      this.$emit('hideFormHouse')
    },
    hideFormHouse () {
      this.$emit('hideFormHouse')
    },
    rowHouseClickHandler (row) {
      if (this.selectedHouse) {
        this.selectedHouse._rowVariant = ''
      }
      this.selectedHouse = row
      this.$set(this.selectedHouse, '_rowVariant', 'info')
    },
    filterChanged (value) {
      this.filter = value
      this.currentPage = 1
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  watch: {
    house: function (val) {
      this.totalRows = val.length()
    }
  },
  mounted () {
    this.totalRows = this.house.length
  },
  computed: {
    house () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/BUILDINGS']))
      for (let el of copy) {
        el.zonesIdString = ''
        for (let elZone of el.zones) {
          if (el.zonesIdString.length) {
            el.zonesIdString += ', '
          }
          el.zonesIdString += elZone
        }
      }
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/contacts/formHouse.vue